import { Injectable } from '@angular/core';
import { IFormWidgetType } from './iform-widget-type.service';
import { ApiService, ApiCacheOptions, PagedSearch, PagedResult, NameDisplayValInteger } from '../../../shared/index'; //app/shared/index barrel;

@Injectable()
export class FormWidgetType implements IFormWidgetType {
  private _availbleWidgetTypes: Array<NameDisplayValInteger>;
  private _apiService: ApiService;

  public constructor(apiService: ApiService) {
    this._apiService = apiService;
    this._availbleWidgetTypes = new Array<NameDisplayValInteger>();
  }

  public getAvailbleWidgetTypes = (): Promise<Array<NameDisplayValInteger>> => {
    if (this._availbleWidgetTypes.length == 0) {
      this._availbleWidgetTypes.push(new NameDisplayValInteger('Heading', 'Add a Heading', 1));
      this._availbleWidgetTypes.push(new NameDisplayValInteger('TextBlock', 'Add a Block of Text', 2));
      this._availbleWidgetTypes.push(new NameDisplayValInteger('Field', 'Add a Field', 3));
      return Promise.resolve(this._availbleWidgetTypes);
    } else {
      return Promise.resolve(this._availbleWidgetTypes);
    }
  };
}
